// extracted by mini-css-extract-plugin
export default {"button":"bj-z","reviewSort":"cj-z"};